"use client";
import {
  useCompositeGroupLabel
} from "../__chunks/Y2MAXF6C.js";
import "../__chunks/IGFP5YPG.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-group-label.tsx
var TagName = "div";
var useComboboxGroupLabel = createHook(function useComboboxGroupLabel2(props) {
  props = useCompositeGroupLabel(props);
  return props;
});
var ComboboxGroupLabel = forwardRef(function ComboboxGroupLabel2(props) {
  const htmlProps = useComboboxGroupLabel(props);
  return createElement(TagName, htmlProps);
});
export {
  ComboboxGroupLabel,
  useComboboxGroupLabel
};
